import React from 'react';

interface CheckboxProps {
  label: React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  compact?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
  className = "",
  compact = false
}) => {
  return (
    <label className={`flex items-start ${compact ? 'space-x-2 py-0.5' : 'space-x-3 py-1'} cursor-pointer group ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className={`${compact ? 'h-3 w-3 mt-1' : 'h-4 w-4 mt-1'} rounded border-slate-400 dark:border-white/20 text-orange-600 focus:ring-2 focus:ring-orange-500 dark:focus:ring-offset-slate-900 transition-all duration-300 cursor-pointer hover:border-orange-500 dark:hover:border-orange-400`}
      />
      <div className={`flex-1 ${compact ? 'text-xs' : 'text-sm'} text-slate-700 dark:text-white font-medium group-hover:text-orange-500 transition-colors`}>
        {label}
      </div>
    </label>
  );
};

export default Checkbox;
